import { createSlice } from "@reduxjs/toolkit";
import { aiRecommendedProducts } from "../../../thunks/buyer-thunks/BuyerThunks";
import { message } from "antd";

const initialState = {
  recommendedProducts: [],
};
export const aiRecommendedSlice = createSlice({
  name: "airecommendations",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    //AI recommended products
    builder
      .addCase(aiRecommendedProducts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(aiRecommendedProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.recommendedProducts = action.payload?.recommended_products;
      })
      .addCase(aiRecommendedProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });
  },
});

export default aiRecommendedSlice.reducer;
